import { render, staticRenderFns } from "./FeaturedUsersAlmostCvTableBody.vue?vue&type=template&id=618ba6a7"
import script from "./FeaturedUsersAlmostCvTableBody.vue?vue&type=script&lang=ts"
export * from "./FeaturedUsersAlmostCvTableBody.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/search/featured-users.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fsearch%2FFeaturedUsersAlmostCvTableBody.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports